module.exports = [{"id":1,"val":"阵容1"},{"id":2,"val":"阵容2"},{"id":3,"val":"阵容3"},{"id":4,"val":"阵容4"},{"id":5,"val":"阵容5"},{"id":101,"val":"部队1"},{"id":102,"val":"部队2"},{"id":103,"val":"部队3"},{"id":104,"val":"部队4"},{"id":201,"val":"竞技场"},{"id":301,"val":"暴走旷野"},{"id":401,"val":"部落战"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/config/lineup_no.json
// module id = UzAh
// module chunks = 1